import { AccountLookup } from "../../../../common/lookups/Layouts/ACLayouts";
import { ActivityLayout } from "../../../../common/lookups/Layouts/CALayouts";
import { FIELD, REFERENCE_MAX_LENGTH } from "./constants";

const HEADER_TABLE = "ACJOURNALHEADER";
const DETAIL_TABLE = "ACJOURNAL";

// The three groups reproduce the legacy form's three group boxes, captions verbatim
// (grpBottomLeft / grpBottomMiddle / grpBottomRight in uWMD0088.dfm). FormField renders one
// col-md-4 fieldset per group, so they sit side by side as they do in Delphi.
//
// DebitAccount / DebitActivity are deliberately required:false — Fields.js emits a static
// RequiredRule with no way to make it conditional, and the legacy rule is "required only when Acct
// Source = User Entered". That is enforced imperatively in the page's validate(). CreditAccount is
// unconditionally required (uWMD0088.pas:363) so it gets the inline marker for free.
//
// isLabelChanged: true everywhere so Fields.js uses the literal label rather than a localization
// lookup — these captions must match the Delphi form and no localization keys exist for them.
const CalculateLayout = [
    {
        groupId: 1,
        label: "AC Journal Transaction",
        fields: [
            {
                name: FIELD.AsOfDate,
                tableName: HEADER_TABLE,
                label: "As Of Date",
                type: "date",
                required: true,
                visible: true,
                isLabelChanged: true,
            },
            {
                name: FIELD.Status,
                tableName: HEADER_TABLE,
                label: "Status",
                type: "select",
                required: true,
                visible: true,
                isLabelChanged: true,
            },
            {
                name: FIELD.Reference,
                tableName: HEADER_TABLE,
                label: "Reference",
                type: "text",
                required: false,
                maxLength: REFERENCE_MAX_LENGTH,
                visible: true,
                isLabelChanged: true,
            },
        ],
    },
    {
        groupId: 2,
        label: "AC Journal Revenue (debit)",
        fields: [
            {
                name: FIELD.AcctSource,
                tableName: DETAIL_TABLE,
                label: "Acct Source",
                type: "select",
                required: true,
                visible: true,
                isLabelChanged: true,
            },
            {
                name: FIELD.DebitAccount,
                tableName: DETAIL_TABLE,
                label: "Account",
                type: "lookup",
                layout: AccountLookup,
                required: false,
                visible: true,
                isLabelChanged: true,
            },
            {
                name: FIELD.DebitActivity,
                tableName: DETAIL_TABLE,
                label: "Activity",
                type: "lookup",
                layout: ActivityLayout,
                required: false,
                visible: true,
                isLabelChanged: true,
            },
        ],
    },
    {
        groupId: 3,
        label: "AC Journal Liability (credit)",
        fields: [
            {
                name: FIELD.UseMgtUnits,
                tableName: DETAIL_TABLE,
                label: "Use Mgt Units",
                type: "select",
                required: true,
                visible: true,
                isLabelChanged: true,
            },
            {
                name: FIELD.CreditAccount,
                tableName: DETAIL_TABLE,
                label: "Account",
                type: "lookup",
                layout: AccountLookup,
                required: true,
                visible: true,
                isLabelChanged: true,
            },
            {
                name: FIELD.CreditActivity,
                tableName: DETAIL_TABLE,
                label: "Activity",
                type: "lookup",
                layout: ActivityLayout,
                required: false,
                visible: true,
                isLabelChanged: true,
            },
        ],
    },
];

export { CalculateLayout };
